import type { DbTagRow } from '../../resolution/types.js';
import type { CodeNavSymbolSpan } from '../../types.js';

export function rowToSymbolSpan(row: DbTagRow, clickable: boolean): CodeNavSymbolSpan {
  return {
    name: row.name,
    startLine: row.start_line + 1,
    startColumn: row.start_column,
    endLine: row.end_line + 1,
    endColumn: row.end_column,
    kind: row.kind,
    role: row.role === 'def' ? 'definition' : 'reference',
    clickable,
  };
}

/** Fast clickability for interactive symbols — skips expensive cross-file resolution. */
export function fastTagIsClickable(row: DbTagRow): boolean {
  if (row.role === 'def') return true;
  if (row.nav_target_path) return true;
  return false;
}
